import React, { FC } from 'react';
import styles from './item_separator.module.scss';

type Props = {};

export const ItemSeparator: React.FC<Props> = () => (
  <hr className={styles.separator} />
);
